import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as widgets from "widgets/register";
import * as QueriesQL from "queries/blog-post";
import { slugOf } from "@common/schema/blog-post/slug";

// The slug follows the title while it is the title's — typing "Hello World"
// offers `hello-world`, and an author who has edited the slug by hand keeps
// what they typed. Gen-2 did the same, with its `postid` too
// (archive/recovered/stack-env/code/site-frontend/src/routes/domain/blog/
// posts/new); here the id is minted and only the slug follows.
export const followTitle = ({ value, previous, parent }) => {
  const current = parent.values.slug || "";

  if (!current || current === slugOf(previous)) {
    parent.setValues({ slug: slugOf(value) });
  }
};

const CREATE_FIELDS = {
  "/Public/BlogPost/Create": {
    fields: [
      { property: "title", onChange: followTitle },
      "slug",
    ],
  },
};

const INITIAL = { title: "", slug: "" };

export const Sidebar = () => null;
export const Indice = () => <BreadcrumbItem>Create</BreadcrumbItem>;

export const Content = ({
  history,
  match: {
    params: { siteId },
  },
}) => {
  const { base } = useSectionContext();

  return (
    <Mutation
      initial={INITIAL}
      target={{ $ref: "/Public/BlogPost/Create" }}
      mutation={QueriesQL.create}
      update={QueriesQL.update()}
      onMutate={({ handler, state: { values: input } }) => {
        handler({ variables: { siteId, input } });
      }}
      onCompleted={(data) => {
        const created = data && data.viewer.account.sites.get.blog.posts.create;
        history.replace(created ? `${base}/${created.postId}/edit` : base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    widgets,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: CREATE_FIELDS,
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Create</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
